/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-button-list[_ngcontent-%COMP%]{background:#fff;margin:5px;font-size:18px;padding:5px 5px 5px 10px;color:#000}.happ-list[_ngcontent-%COMP%]{flex-wrap:wrap}[_nghost-%COMP%]     .mat-form-field-underline{background-color:rgba(63,60,60,.45)!important}[_nghost-%COMP%]   [_ngcontent-%COMP%]::-webkit-input-placeholder{color:red;transition:opacity 250ms ease-in-out}.header-or-footer-button[_ngcontent-%COMP%]{flex-wrap:wrap;justify-content:center;align-items:center}.happ-small-button[_ngcontent-%COMP%]{line-height:25px!important}"];
export { styles as styles };
